export default {
  EmptyState: {
    title: 'Adăugați primul dvs. restaurant',
    description: 'Nu aveți niciun restaurant încă. Creați unul pentru a începe configurarea și primirea comenzilor.',
    cta: 'Restaurant nou',
  },
};
